import React, { FC } from 'react'

const CircleCheckIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM14.0038 8.69155C14.4531 8.3847 14.5686 7.77169 14.2618 7.32234C13.955 6.87298 13.3419 6.75746 12.8926 7.0643L12.7928 7.13245C11.1762 8.23637 9.78264 9.62986 8.68064 11.2389L7.24791 9.80766C6.86295 9.42311 6.23915 9.42344 5.8546 9.8084C5.47005 10.1934 5.47038 10.8172 5.85534 11.2017L8.16194 13.5058C8.37907 13.7228 8.68489 13.8261 8.98908 13.7853C9.29328 13.7445 9.5611 13.5643 9.71346 13.2979C10.7488 11.4875 12.1817 9.93578 13.904 8.7597L14.0038 8.69155Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleCheckIcon
